import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
// colores poncho
  theme: {
    primary: '#0695d6',
    secondary: '#01bdf2',
    accent: '#82B1FF',
    error: '#ef4d3d',
    info: '#5bc0de',
    success: '#33b560',
    warning: '#fec221'
  }
})
